import { render, staticRenderFns } from "./ReconArrearDetail.vue?vue&type=template&id=1cc988fd&scoped=true&"
import script from "./ReconArrearDetail.vue?vue&type=script&lang=js&"
export * from "./ReconArrearDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReconArrearDetail.vue?vue&type=style&index=0&id=1cc988fd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc988fd",
  null
  
)

export default component.exports